/* ============================================================
   FIT FINDER — Rose on Six bra size calculator
   ------------------------------------------------------------
   INTEGRATION CONTRACT — read this and you should not need to ask.

   1. TRIGGER
      Add data-ff-open to any element:

          <a href="#" data-ff-open>Meine perfekte Größe finden</a>

      Listeners are DELEGATED on `document`. This keeps working when
      Shopify re-renders the section on a variant change.
      Do NOT bind a click handler directly to the link — it will die
      the first time the DOM is swapped.

   2. EVENT
      On every result this fires on `document`:

          fitfinder:result
            detail: { size, band, cup, entered, answers, inRange }

      Hook GA4 / Klaviyo onto this. Never read the size from the DOM.

   3. RANGE
      Bands 70–120 (5-step). Cups A–H. EU/DACH only.
      No stock check — the size picker already tells her what this
      product has. The quiz's job is to tell her HER size.

   4. THE LOGIC (settled — do not "fix" this)
      a. Band first. Band drives the fit.
      b. Sister-size the cup so VOLUME stays constant when the band
         moves. Band down 1 → cup up 1. Band up 1 → cup down 1.
      c. Apply her cup answer to the SISTER-SIZED cup, not to the
         cup she typed. Always ±1 volume step, never ±2.
   ============================================================ */

(function () {
  'use strict';

  var CFG = Object.assign({
    brand: 'Rose on Six',
    market: 'EU',        // 'EU' (DACH) or 'US'
    locale: 'de',        // 'de' or 'en'
    debug: false
  }, window.FF_CONFIG || {});

  /* Engine works on EU indices internally — the physics is the same in
     every market. Only the LABELS differ, so we relabel at display time.
     Index-aligned: EU 75C === US 34C === index [1][2]. */
  var BANDS = ['70','75','80','85','90','95','100','105','110','115','120'];
  var CUPS  = ['A','B','C','D','E','F','G','H'];

  var LABELS = {
    EU: { bands: BANDS, cups: CUPS },
    US: {
      bands: ['30','32','34','36','38','40','42','44','46','48','50'],
      cups:  ['A','B','C','D','DD','DDD','G','H']   // E=DD, F=DDD, G=G, H=H
    }
  };
  var MK = LABELS[CFG.market] || LABELS.EU;

  // index -> market label
  function bandLabel(i){ return MK.bands[i]; }
  function cupLabel(i){ return MK.cups[i]; }
  // market label -> index (for reading Q1 pills back)
  function bandIndex(v){ return MK.bands.indexOf(v); }
  function cupIndex(v){ return MK.cups.indexOf(v); }
  var COPY = {
    de: {
      q1:'Welche Größe trägst du aktuell?',
      q1hint:'Denk an den BH, der dir am besten passt',
      band:'Unterbrustweite', cup:'Cupgröße',

      q2:'Wie sitzen die Cups?',
      q2hint:'Denk an den BH aus Frage 1',
      q3:'Wie sitzt das Unterbrustband?',
      q3hint:'Das Band trägt rund 80 % des Halts',
      q4:'Auf welcher Hakenreihe trägst du ihn?',
      q4hint:'Verrät uns, wie viel Spielraum das Band noch hat',

      o_cupSmall:'Zu klein',   o_cupSmallSub:'Deine Brust quillt oben oder seitlich über',
      o_cupOk:'Perfekt',       o_cupOkSub:'Glatt anliegend — kein Spalt, kein Überquellen',
      o_cupBig:'Zu groß',      o_cupBigSub:'Der Cup steht ab oder wirft Falten',
      o_bandTight:'Zu eng',    o_bandTightSub:'Es schneidet ein oder drückt',
      o_bandOk:'Perfekt',      o_bandOkSub:'Waagerecht und fest',
      o_bandLoose:'Zu locker', o_bandLooseSub:'Es rutscht hinten hoch',
      o_hookTight:'Engste',    o_hookTightSub:'Innerste Haken',
      o_hookMid:'Mittlere',    o_hookMidSub:'',
      o_hookLoose:'Weiteste',  o_hookLooseSub:'Äußerste Haken',

      frage:'Frage', back:'Zurück', next:'Weiter', show:'Größe anzeigen',
      close:'Schließen',

      recTitle:'Deine empfohlene Größe',
      okTitle:'Deine Größe stimmt',
      entered:'Du hast <b>{x}</b> angegeben',
      same:'Genau die Größe, die du schon trägst',
      whyRec:'Warum diese Größe',
      whyOk:'Was wir geprüft haben',
      shop:'Jetzt shoppen',
      again:'Nochmal starten',

      nBandLow:'Deine Angaben deuten auf ein Unterbrustband unter <b>{min}</b>. Unser Sortiment startet bei {min} — <b>{s}</b> ist die beste Passform, die wir dir anbieten können.',
      nBandHigh:'Deine Angaben deuten auf ein Unterbrustband über <b>{max}</b>. Unser Sortiment endet bei {max} — <b>{s}</b> ist die beste Passform, die wir dir anbieten können.',
      nCupLow:'Deine Angaben deuten auf einen Cup unter <b>{min}</b>. Unser Sortiment startet bei {min} — <b>{s}</b> ist die beste Passform, die wir dir anbieten können.',
      nCupHigh:'Deine Angaben deuten auf einen Cup über <b>{max}</b>. Unser Sortiment endet bei {max} — <b>{s}</b> ist die beste Passform, die wir dir anbieten können.',

      rTight:'Band <b>{a} → {b}</b>: Du hast angegeben, dass es zu eng sitzt.',
      rLoose:'Band <b>{a} → {b}</b>: Du hast angegeben, dass es zu locker sitzt.',
      rHook:'Band <b>{a} → {b}</b>: Du trägst ihn schon auf der engsten Hakenreihe. Enger geht er nicht — und er wird mit der Zeit noch weiter.',
      rBandOk:'Band <b>{a}</b>: Sitzt richtig — und du hast auf den Haken noch Spielraum.',
      rSisUp:'Cup <b>{a} → {b}</b>: Ein schmaleres Band braucht einen größeren Cup für dasselbe Volumen. Deine Brust bleibt gleich — nur der Rahmen sitzt fester.',
      rSisDn:'Cup <b>{a} → {b}</b>: Ein breiteres Band braucht einen kleineren Cup für dasselbe Volumen. Deine Brust bleibt gleich — nur der Rahmen sitzt weiter.',
      rCupSm:'Cup weiter auf <b>{b}</b>: Du hast angegeben, dass die Cups zu klein sind.',
      rCupBg:'Cup weiter auf <b>{b}</b>: Du hast angegeben, dass die Cups zu groß sind.',
      rCupOk:'Cup <b>{a}</b>: Das Volumen passt. Kein Überquellen, kein Spalt.',
      rTip:'Sitzt das Band auf der weitesten Reihe zu locker, zieh es erst enger — vielleicht brauchst du gar keine neue Größe.'
    },

    en: {
      q1:'What size are you wearing now?',
      q1hint:'Think of the bra that fits you best',
      band:'Band size', cup:'Cup size',

      q2:'How do the cups fit?',
      q2hint:'Think of the bra from question 1',
      q3:'How does the band fit?',
      q3hint:'The band carries about 80% of the support',
      q4:'Which hook are you wearing it on?',
      q4hint:'Tells us how much room the band has left',

      o_cupSmall:'Too small',  o_cupSmallSub:'Your breast spills over the top or the side',
      o_cupOk:'Just right',    o_cupOkSub:'Smooth — no gap, no spillage',
      o_cupBig:'Too big',      o_cupBigSub:'The cup gaps or wrinkles',
      o_bandTight:'Too tight', o_bandTightSub:'It digs in',
      o_bandOk:'Just right',   o_bandOkSub:'Level and firm',
      o_bandLoose:'Too loose', o_bandLooseSub:'It rides up at the back',
      o_hookTight:'Tightest',  o_hookTightSub:'Innermost hooks',
      o_hookMid:'Middle',      o_hookMidSub:'',
      o_hookLoose:'Loosest',   o_hookLooseSub:'Outermost hooks',

      frage:'Question', back:'Back', next:'Next', show:'Show my size',
      close:'Close',

      recTitle:'Your recommended size',
      okTitle:'Your size is right',
      entered:'You entered <b>{x}</b>',
      same:'Exactly the size you already wear',
      whyRec:'Why this size',
      whyOk:'What we checked',
      shop:'Shop now',
      again:'Start over',

      nBandLow:'Your answers point to a band below <b>{min}</b>. Our range starts at {min} — <b>{s}</b> is the closest fit we can offer you.',
      nBandHigh:'Your answers point to a band above <b>{max}</b>. Our range stops at {max} — <b>{s}</b> is the closest fit we can offer you.',
      nCupLow:'Your answers point to a cup below <b>{min}</b>. Our range starts at {min} — <b>{s}</b> is the closest fit we can offer you.',
      nCupHigh:'Your answers point to a cup above <b>{max}</b>. Our range stops at {max} — <b>{s}</b> is the closest fit we can offer you.',

      rTight:'Band <b>{a} → {b}</b>: you said it fits too tight.',
      rLoose:'Band <b>{a} → {b}</b>: you said it fits too loose.',
      rHook:'Band <b>{a} → {b}</b>: you are already on the tightest hook. It will not go smaller — and it only stretches with time.',
      rBandOk:'Band <b>{a}</b>: fits right — and you still have room on the hooks.',
      rSisUp:'Cup <b>{a} → {b}</b>: a narrower band needs a bigger cup for the same volume. Your breast stays the same — the frame just holds firmer.',
      rSisDn:'Cup <b>{a} → {b}</b>: a wider band needs a smaller cup for the same volume. Your breast stays the same — the frame just sits looser.',
      rCupSm:'Cup up to <b>{b}</b>: you said the cups run too small.',
      rCupBg:'Cup down to <b>{b}</b>: you said the cups run too big.',
      rCupOk:'Cup <b>{a}</b>: the volume is right. No spillage, no gap.',
      rTip:'If the band is loose on the outermost hooks, tighten it first — you may not need a new size at all.'
    }
  };

  var T = COPY[CFG.locale] || COPY.de;

  function clamp(n,lo,hi){ return Math.max(lo, Math.min(hi, n)); }
  function fill(s,m){ return String(s).replace(/\{(\w+)\}/g, function(_,k){ return m[k]!=null?m[k]:''; }); }
  function esc(s){ return String(s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  /* ============================================================
     THE ALGORITHM
     ============================================================ */
  function compute(a){
    /* a.band / a.cup arrive as MARKET labels (from the Q1 pills).
       Resolve to indices, do all math on indices, emit market labels. */
    var bi = bandIndex(a.band), ci = cupIndex(a.cup);
    if (bi < 0 || ci < 0) return null;

    var why = [], tip = null, delta = 0;

    /* 1 — band */
    if (a.bandFit === 'tight')      delta = 1;
    else if (a.bandFit === 'loose') { delta = -1; if (a.hook === 'loosest') tip = T.rTip; }
    else if (a.hook === 'tightest') delta = -1;   // out of adjustment: band is too big for her

    var rawB = bi + delta;
    var nbi = clamp(rawB, 0, BANDS.length - 1);
    var applied = nbi - bi;

    /* 2 — sister-size: hold volume constant */
    var rawC = ci - applied;
    var preC = clamp(rawC, 0, CUPS.length - 1);

    /* 3 — her cup answer, applied to the sister-sized cup */
    if (a.cupFit === 'small') rawC += 1;
    else if (a.cupFit === 'big') rawC -= 1;
    var nci = clamp(rawC, 0, CUPS.length - 1);

    var bandLow = rawB < 0, bandHigh = rawB > BANDS.length - 1;
    var cupLow  = rawC < 0, cupHigh  = rawC > CUPS.length - 1;
    var inRange = !bandLow && !bandHigh && !cupLow && !cupHigh;

    var size = bandLabel(nbi) + cupLabel(nci);
    var entered = bandLabel(bi) + cupLabel(ci);
    var confirm = (size === entered) && inRange;

    /* --- reasoning (all labels via bandLabel/cupLabel) --- */
    if (confirm) {
      why.push(fill(T.rBandOk, { a: bandLabel(bi) }));
      why.push(fill(T.rCupOk,  { a: cupLabel(ci) }));
    } else {
      if (delta === 0 && applied === 0) {
        why.push(fill(T.rBandOk, { a: bandLabel(bi) }));
      } else if (applied !== 0) {
        if (a.bandFit === 'tight')      why.push(fill(T.rTight, { a: bandLabel(bi), b: bandLabel(nbi) }));
        else if (a.bandFit === 'loose') why.push(fill(T.rLoose, { a: bandLabel(bi), b: bandLabel(nbi) }));
        else                            why.push(fill(T.rHook,  { a: bandLabel(bi), b: bandLabel(nbi) }));
      }
      /* if applied === 0 but delta !== 0 the band was clamped at the edge —
         say nothing here, the notice explains it honestly. */

      if (applied !== 0) {
        why.push(fill(applied < 0 ? T.rSisUp : T.rSisDn, { a: cupLabel(ci), b: cupLabel(preC) }));
      }

      /* only claim we moved the cup if we actually could */
      if (a.cupFit === 'small' && nci !== preC) why.push(fill(T.rCupSm, { b: cupLabel(nci) }));
      else if (a.cupFit === 'big' && nci !== preC) why.push(fill(T.rCupBg, { b: cupLabel(nci) }));

      if (!why.length) why.push(fill(T.rBandOk, { a: bandLabel(bi) }));
    }
    if (tip) why.push(tip);

    /* --- out-of-range notice --- */
    var note = '';
    var bMin = bandLabel(0), bMax = bandLabel(BANDS.length - 1);
    var cMin = cupLabel(0),  cMax = cupLabel(CUPS.length - 1);
    if (bandLow)       note = fill(T.nBandLow,  { s: size, min: bMin });
    else if (bandHigh) note = fill(T.nBandHigh, { s: size, max: bMax });
    else if (cupLow)   note = fill(T.nCupLow,   { s: size, min: cMin });
    else if (cupHigh)  note = fill(T.nCupHigh,  { s: size, max: cMax });

    return {
      size: size, band: bandLabel(nbi), cup: cupLabel(nci),
      entered: entered, confirm: confirm, inRange: inRange,
      why: why, note: note
    };
  }

  /* ============================================================
     UI
     ============================================================ */
  var STEPS = [
    { key:'size', type:'size', q:T.q1, hint:T.q1hint },
    { key:'cupFit', type:'pick', q:T.q2, hint:T.q2hint, opts:[
      { v:'small', t:T.o_cupSmall, s:T.o_cupSmallSub },
      { v:'ok',    t:T.o_cupOk,    s:T.o_cupOkSub },
      { v:'big',   t:T.o_cupBig,   s:T.o_cupBigSub }
    ]},
    { key:'bandFit', type:'pick', q:T.q3, hint:T.q3hint, opts:[
      { v:'tight', t:T.o_bandTight, s:T.o_bandTightSub },
      { v:'ok',    t:T.o_bandOk,    s:T.o_bandOkSub },
      { v:'loose', t:T.o_bandLoose, s:T.o_bandLooseSub }
    ]},
    { key:'hook', type:'pick', q:T.q4, hint:T.q4hint, opts:[
      { v:'tightest', t:T.o_hookTight, s:T.o_hookTightSub, h:[1,0,0] },
      { v:'middle',   t:T.o_hookMid,   s:T.o_hookMidSub,   h:[0,1,0] },
      { v:'loosest',  t:T.o_hookLoose, s:T.o_hookLooseSub, h:[0,0,1] }
    ]}
  ];

  var overlay, modal, body, bar, state, step, lastFocus;

  function reset(){ state = { band:'', cup:'', cupFit:'', bandFit:'', hook:'' }; step = 0; }

  function drawBar(){
    bar.innerHTML = '';
    for (var i = 0; i < STEPS.length; i++) {
      var d = document.createElement('div');
      d.className = 'ff-bar__seg' + ((step >= STEPS.length || i <= step) ? ' is-on' : '');
      bar.appendChild(d);
    }
  }

  function ready(){
    var S = STEPS[step];
    return S.type === 'size' ? !!(state.band && state.cup) : !!state[S.key];
  }
  function syncCta(){
    var c = body.querySelector('[data-ff-next]');
    if (c) c.classList.toggle('is-ready', ready());
  }
  function nudge(){
    var el = body.querySelector('.ff-opts, .ff-q1');
    if (!el) return;
    el.classList.remove('is-nudge'); void el.offsetWidth; el.classList.add('is-nudge');
  }

  function render(){
    drawBar();
    if (step >= STEPS.length) { renderResult(); return; }

    var S = STEPS[step], h = '<div class="ff-step">';
    h += '<p class="ff-eyebrow">' + T.frage + ' ' + (step + 1) + ' / ' + STEPS.length + '</p>';
    h += '<h2 class="ff-q" id="ffTitle">' + esc(S.q) + '</h2>';
    h += '<p class="ff-hint">' + esc(S.hint) + '</p>';

    if (S.type === 'size') {
      h += '<div class="ff-q1">';
      h += '<p class="ff-lbl">' + T.band + '</p><div class="ff-grid ff-grid--band" role="group" aria-label="' + T.band + '">';
      h += MK.bands.map(function(b){
        return '<button type="button" class="ff-pill' + (state.band === b ? ' is-on' : '') +
               '" data-ff-band="' + b + '" aria-pressed="' + (state.band === b) + '">' + b + '</button>';
      }).join('');
      h += '</div>';
      h += '<p class="ff-lbl">' + T.cup + '</p><div class="ff-grid ff-grid--cup" role="group" aria-label="' + T.cup + '">';
      h += MK.cups.map(function(c){
        return '<button type="button" class="ff-pill' + (state.cup === c ? ' is-on' : '') +
               '" data-ff-cup="' + c + '" aria-pressed="' + (state.cup === c) + '">' + c + '</button>';
      }).join('');
      h += '</div></div>';
    } else {
      h += '<div class="ff-opts" role="group" aria-label="' + esc(S.q) + '">';
      h += S.opts.map(function(o){
        var on = state[S.key] === o.v;
        var hooks = o.h ? '<span class="ff-hooks" aria-hidden="true">' + o.h.map(function(x){
          return '<span class="ff-hook' + (x ? ' is-on' : '') + '"></span>';
        }).join('') + '</span>' : '';
        return '<button type="button" class="ff-opt' + (on ? ' is-on' : '') + '" data-ff-pick="' + o.v + '" aria-pressed="' + on + '">' +
               '<span class="ff-dot" aria-hidden="true"></span>' +
               '<span><span class="ff-opt__t">' + esc(o.t) + '</span>' +
               (o.s ? '<span class="ff-opt__s">' + esc(o.s) + '</span>' : '') + '</span>' +
               hooks + '</button>';
      }).join('');
      h += '</div>';
    }

    h += '<div class="ff-nav">';
    h += '<button type="button" class="ff-back" data-ff-back' + (step === 0 ? ' hidden' : '') + '>&#8592; ' + T.back + '</button>';
    h += '<button type="button" class="ff-cta" data-ff-next>' + (step === STEPS.length - 1 ? T.show : T.next) + '</button>';
    h += '</div></div>';

    body.innerHTML = h;
    syncCta();
    var f = body.querySelector('.ff-pill, .ff-opt');
    if (f) f.focus();
  }

  function renderResult(){
    var r = compute(state);
    if (!r) { step = 0; render(); return; }

    var h = '<div class="ff-step ff-result">';
    h += '<p class="ff-eyebrow" id="ffTitle">' + (r.confirm ? T.okTitle : T.recTitle) + '</p>';
    h += '<div class="ff-tag">';
    h += '<p class="ff-tag__brand">' + esc(CFG.brand) + '</p>';
    h += '<p class="ff-tag__size">' + esc(r.size) + '</p>';
    h += '</div>';
    h += '<p class="ff-entered">' + (r.confirm ? T.same : fill(T.entered, { x: esc(r.entered) })) + '</p>';
    if (r.note) h += '<div class="ff-note"><p>' + r.note + '</p></div>';
    h += '<div class="ff-why"><p class="ff-eyebrow" style="margin-bottom:12px">' + (r.confirm ? T.whyOk : T.whyRec) + '</p>';
    h += '<ul class="ff-why__list">' + r.why.map(function(w){ return '<li>' + w + '</li>'; }).join('') + '</ul></div>';
    h += '<button type="button" class="ff-cta ff-cta--full is-ready" data-ff-close style="margin-top:26px">' + T.shop + '</button>';
    h += '<div><button type="button" class="ff-again" data-ff-again>' + T.again + '</button></div>';
    h += '</div>';

    body.innerHTML = h;
    var c = body.querySelector('[data-ff-close]');
    if (c) c.focus();

    document.dispatchEvent(new CustomEvent('fitfinder:result', {
      detail: {
        size: r.size, band: r.band, cup: r.cup,
        entered: r.entered, answers: Object.assign({}, state), inRange: r.inRange
      }
    }));
    if (CFG.debug) console.log('[fit-finder]', r);
  }

  function open(){
    if (!overlay) return;
    lastFocus = document.activeElement;
    reset();
    overlay.hidden = false;
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    render();
  }
  function close(){
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function init(){
    overlay = document.getElementById('ffOverlay');
    if (!overlay) return;
    modal = document.getElementById('ffModal');
    body  = document.getElementById('ffBody');
    bar   = document.getElementById('ffBar');
    reset();

    /* Selecting an option toggles classes IN PLACE. It must never call
       render() — a full re-render re-fires the step-change slide, which
       makes every tap look like a page transition. */
    function selectIn(group, el, val, key){
      var sibs = group.querySelectorAll('button');
      for (var i = 0; i < sibs.length; i++) {
        sibs[i].classList.remove('is-on');
        sibs[i].setAttribute('aria-pressed', 'false');
      }
      el.classList.add('is-on');
      el.setAttribute('aria-pressed', 'true');
      state[key] = val;
      syncCta();
    }

    body.addEventListener('click', function(e){
      var b = e.target.closest('[data-ff-band]');
      if (b) { selectIn(b.parentNode, b, b.getAttribute('data-ff-band'), 'band'); return; }
      var c = e.target.closest('[data-ff-cup]');
      if (c) { selectIn(c.parentNode, c, c.getAttribute('data-ff-cup'), 'cup'); return; }
      var p = e.target.closest('[data-ff-pick]');
      if (p) { selectIn(p.parentNode, p, p.getAttribute('data-ff-pick'), STEPS[step].key); return; }
      if (e.target.closest('[data-ff-next]')) {
        if (!ready()) { nudge(); return; }
        step++; render(); return;
      }
      if (e.target.closest('[data-ff-back]')) { step--; render(); return; }
      if (e.target.closest('[data-ff-again]')) { reset(); render(); return; }
    });

    /* Delegated on document — survives Shopify section re-renders. */
    document.addEventListener('click', function(e){
      if (e.target.closest('[data-ff-open]'))  { e.preventDefault(); open(); }
      if (e.target.closest('[data-ff-close]')) { close(); }
    });

    overlay.addEventListener('mousedown', function(e){ if (e.target === overlay) close(); });

    document.addEventListener('keydown', function(e){
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = modal.querySelectorAll('button:not([hidden])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.FitFinder = { open: open, close: close, compute: compute, bands: MK.bands, cups: MK.cups, config: CFG };
})();
